<div class="search-page">
  <app-header></app-header>

  <main class="search-content">
    <div class="search-header">
      <div class="search-header-content">
        <h1 class="search-title">
          <span *ngIf="isReverseImageSearch && reverseSearchResults.length > 0">
            {{ reverseSearchResults.length | number }} similar items found
          </span>
          <span
            *ngIf="
              isReverseImageSearch &&
              reverseSearchResults.length === 0 &&
              !isLoading
            "
          >
            No similar items found
          </span>
          <span *ngIf="isReverseImageSearch && isLoading">
            Analyzing image...
          </span>

          <span *ngIf="!isReverseImageSearch && !isLoading && searchResult">
            {{ searchResult.pagination.total | number }} results found
          </span>
          <span *ngIf="!isReverseImageSearch && isLoading && currentKeyword"
            >Searching...</span
          >
          <span *ngIf="!isReverseImageSearch && isLoading && !currentKeyword"
            >Loading...</span
          >
          <span
            *ngIf="
              !isReverseImageSearch &&
              !isLoading &&
              !searchResult &&
              currentKeyword
            "
            >Search Results</span
          >
          <span
            *ngIf="
              !isReverseImageSearch &&
              !isLoading &&
              !searchResult &&
              !currentKeyword &&
              currentCategory === 'all'
            "
            >Browse Categories</span
          >
          <span
            *ngIf="
              !isReverseImageSearch &&
              !isLoading &&
              !searchResult &&
              !currentKeyword &&
              currentCategory !== 'all'
            "
            >Browse {{ getCategoryDisplayName(currentCategory) }}</span
          >
        </h1>

        <div class="search-breadcrumb">
          <a routerLink="/home">Home</a>
          <span class="breadcrumb-separator">›</span>

          <span *ngIf="isReverseImageSearch">AI Image Search</span>

          <span *ngIf="!isReverseImageSearch && currentKeyword">Search</span>
          <span *ngIf="!isReverseImageSearch && !currentKeyword">Browse</span>
          <span
            *ngIf="!isReverseImageSearch && currentCategory !== 'all'"
            class="breadcrumb-separator"
            >›</span
          >
          <span *ngIf="!isReverseImageSearch && currentCategory !== 'all'">{{
            getCategoryDisplayName(currentCategory)
          }}</span>
          <span
            *ngIf="
              !isReverseImageSearch &&
              (currentSubcategory || pendingSubcategory)
            "
            class="breadcrumb-separator"
            >›</span
          >
          <span
            *ngIf="
              !isReverseImageSearch && currentSubcategory && !pendingSubcategory
            "
            >{{ getSubcategoryDisplayName(currentSubcategory) }}</span
          >
          <span
            *ngIf="!isReverseImageSearch && pendingSubcategory"
            class="breadcrumb-changing"
            >{{ getSubcategoryDisplayName(pendingSubcategory) }}</span
          >
        </div>
      </div>
    </div>

    <div
      *ngIf="isReverseImageSearch && searchImageUrl"
      class="reverse-search-info"
    >
      <div class="reverse-search-info-content">
        <div class="search-image-container">
          <img [src]="searchImageUrl" alt="Search Image" class="search-image" />
          <div class="search-image-label">
            <svg viewBox="0 0 24 24" class="search-label-icon">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            Your Search Image
          </div>
        </div>
        <div class="reverse-search-details">
          <h3>AI Image Search Results</h3>
          <p>Found similar items using advanced AI image recognition</p>
          <div class="search-stats">
            <span class="stat-item">
              <strong>{{ reverseSearchResults.length }}</strong> similar items
            </span>
            <span class="stat-item">
              <strong>{{ getCategoryDisplayName(currentCategory) }}</strong>
              category
            </span>
            <span class="stat-item" *ngIf="reverseSearchData">
              <strong
                >{{
                  reverseSearchData.params.similarity_threshold * 100
                    | number : "1.0-0"
                }}%</strong
              >
              similarity threshold
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="search-controls"
      *ngIf="
        (!isLoading && searchResult) ||
        (isReverseImageSearch && reverseSearchResults.length > 0)
      "
      [class.fade-in]="resultsVisible"
      [class.fade-out]="!resultsVisible"
    >
      <div class="search-controls-content">
        <div class="search-info">
          <p
            class="search-query"
            *ngIf="!isReverseImageSearch && currentKeyword"
          >
            <strong>"{{ currentKeyword }}"</strong>
            <span *ngIf="currentCategory !== 'all'">
              in {{ getCategoryDisplayName(currentCategory) }}</span
            >
            <span *ngIf="currentSubcategory && !isChangingSubcategory">
              › {{ getSubcategoryDisplayName(currentSubcategory) }}</span
            >
            <span *ngIf="isChangingSubcategory && pendingSubcategory">
              › {{ getSubcategoryDisplayName(pendingSubcategory) }}</span
            >
          </p>
          <p
            class="search-query"
            *ngIf="
              !isReverseImageSearch &&
              !currentKeyword &&
              currentCategory !== 'all'
            "
          >
            Browsing
            <strong>{{ getCategoryDisplayName(currentCategory) }}</strong>
            <span *ngIf="currentSubcategory && !isChangingSubcategory">
              › {{ getSubcategoryDisplayName(currentSubcategory) }}</span
            >
            <span *ngIf="isChangingSubcategory && pendingSubcategory">
              › {{ getSubcategoryDisplayName(pendingSubcategory) }}</span
            >
          </p>
          <p
            class="search-query"
            *ngIf="
              !isReverseImageSearch &&
              !currentKeyword &&
              currentCategory === 'all'
            "
          >
            Browsing <strong>All Categories</strong>
          </p>

          <p class="search-query" *ngIf="isReverseImageSearch">
            AI-powered image search results in
            <strong>{{ getCategoryDisplayName(currentCategory) }}</strong>
            <span *ngIf="reverseSearchData">
              with
              {{
                reverseSearchData.params.similarity_threshold * 100
                  | number : "1.0-0"
              }}% minimum similarity
            </span>
          </p>
        </div>

        <div class="search-sort">
          <label *ngIf="!isReverseImageSearch"
            >Sort by:
            <select
              [(ngModel)]="currentSort"
              (ngModelChange)="updateUrl({ sort: currentSort, page: 1 })"
              class="sort-select"
              [disabled]="isChangingSubcategory"
            >
              <option value="relevance">Most Relevant</option>
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="price_low">Price: Low to High</option>
              <option value="price_high">Price: High to Low</option>
            </select>
          </label>

          <label *ngIf="isReverseImageSearch"
            >Sort by:
            <select
              [(ngModel)]="currentSort"
              (ngModelChange)="sortReverseSearchResults()"
              class="sort-select"
            >
              <option value="similarity">Best Match</option>
              <option value="newest">Newest First</option>
              <option value="price_low">Price: Low to High</option>
              <option value="price_high">Price: High to Low</option>
            </select>
          </label>
        </div>
      </div>
    </div>

    <div
      class="search-results"
      *ngIf="
        (!isLoading && searchResult && searchResult.listings.length > 0) ||
        (isReverseImageSearch && reverseSearchResults.length > 0)
      "
      [class.fade-in]="resultsVisible"
      [class.fade-out]="!resultsVisible"
    >
      <div class="results-grid">
        <ng-container *ngIf="!isReverseImageSearch">
          <article
            *ngFor="
              let result of processedListings;
              let i = index;
              trackBy: trackByListingId
            "
            class="listing-card"
            [class.fade-in-delayed]="resultsVisible"
            [style.animation-delay]="(i % 20) * 50 + 'ms'"
            (mouseenter)="onListingHover(result)"
            (mouseleave)="onListingLeave(result)"
          >
            <div
              class="listing-image-container"
              (touchstart)="onTouchStart($event, result)"
              (touchmove)="onTouchMove($event, result)"
              (touchend)="onTouchEnd($event, result)"
            >
              <div
                class="image-wrapper"
                [class.loading]="result.isImageLoading"
              >
                <img
                  [src]="result.displayImage"
                  [alt]="result.title"
                  class="listing-image"
                  loading="lazy"
                  (load)="onImageLoad(result.displayImage, result)"
                  (error)="onImageError($event, result)"
                />

                <div
                  class="image-loading-overlay"
                  *ngIf="result.isImageLoading"
                >
                  <div class="spinner"></div>
                </div>

                <div class="image-overlay"></div>
              </div>

              <div
                class="image-click-zones desktop-only"
                *ngIf="hasMultipleImages(result)"
              >
                <div
                  class="click-zone zone-left"
                  (click)="onImageZoneClick($event, result, 'prev')"
                  [attr.aria-label]="'Previous image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </div>
                </div>
                <div
                  class="click-zone zone-middle"
                  (click)="onImageZoneClick($event, result, 'view')"
                ></div>
                <div
                  class="click-zone zone-right"
                  (click)="onImageZoneClick($event, result, 'next')"
                  [attr.aria-label]="'Next image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="carousel-controls desktop-only"
                *ngIf="hasMultipleImages(result) && result.showCarouselControls"
                [class.fading-out]="!result.showCarouselControls"
              >
                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>

                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>

              <div
                class="image-counter desktop-only"
                *ngIf="hasMultipleImages(result)"
              >
                {{ getImageCounter(result) }}
              </div>

              <div
                class="image-dots mobile-only"
                *ngIf="hasMultipleImages(result)"
              >
                <span
                  *ngFor="let img of result.images; let i = index"
                  class="dot"
                  [class.active]="i === result.currentImageIndex"
                ></span>
              </div>

              <div class="listing-badges">
                <div *ngIf="result.is_featured" class="listing-badge featured">
                  Featured
                </div>
                <div
                  *ngIf="isNewListing(result.created_at)"
                  class="listing-badge new"
                >
                  New
                </div>
              </div>

              <div class="listing-bookmark" (click)="$event.stopPropagation()">
                <app-wishlist-heart
                  [listingId]="result.id.toString()"
                  [tableName]="result.table_name"
                  *ngIf="shouldShowWishlistButton(result)"
                ></app-wishlist-heart>
              </div>
            </div>

            <div class="listing-content" (click)="viewListing(result)">
              <div class="listing-main-info">
                <div class="listing-header">
                  <h3 class="listing-title">{{ result.title }}</h3>
                </div>
                <div class="listing-price-wrapper">
                  <div class="listing-price">
                    <span *ngIf="result.price > 0">
                      <span class="price-currency">{{
                        result.currency || "€"
                      }}</span>
                      <span class="price-value">{{
                        result.price | number : "1.0-0"
                      }}</span>
                    </span>
                    <span *ngIf="result.price === 0" class="price-free">
                      Free
                    </span>
                  </div>
                </div>
                <div class="listing-details-grid">
                  <div class="listing-location" *ngIf="result.location">
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                      ></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ result.location }}</span>
                  </div>
                  <div
                    class="listing-views"
                    *ngIf="result.view_count && result.view_count > 0"
                  >
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span>{{ result.view_count }} views</span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </ng-container>

        <ng-container *ngIf="isReverseImageSearch">
          <article
            *ngFor="
              let result of reverseSearchResults;
              let i = index;
              trackBy: trackByListingId
            "
            class="listing-card reverse-result-card"
            [class.fade-in-delayed]="resultsVisible"
            [style.animation-delay]="(i % 20) * 50 + 'ms'"
            (mouseenter)="onListingHover(result)"
            (mouseleave)="onListingLeave(result)"
          >
            <div
              class="listing-image-container"
              (touchstart)="onTouchStart($event, result)"
              (touchmove)="onTouchMove($event, result)"
              (touchend)="onTouchEnd($event, result)"
            >
              <div
                class="image-wrapper"
                [class.loading]="result.isImageLoading"
              >
                <img
                  [src]="result.displayImage"
                  [alt]="result.title"
                  class="listing-image"
                  loading="lazy"
                  (load)="onImageLoad(result.displayImage, result)"
                  (error)="onImageError($event, result)"
                />

                <div
                  class="image-loading-overlay"
                  *ngIf="result.isImageLoading"
                >
                  <div class="spinner"></div>
                </div>

                <div class="image-overlay"></div>
              </div>

              <div
                class="image-click-zones desktop-only"
                *ngIf="hasMultipleImages(result)"
              >
                <div
                  class="click-zone zone-left"
                  (click)="onImageZoneClick($event, result, 'prev')"
                  [attr.aria-label]="'Previous image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </div>
                </div>
                <div
                  class="click-zone zone-middle"
                  (click)="onImageZoneClick($event, result, 'view')"
                ></div>
                <div
                  class="click-zone zone-right"
                  (click)="onImageZoneClick($event, result, 'next')"
                  [attr.aria-label]="'Next image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="carousel-controls desktop-only"
                *ngIf="hasMultipleImages(result) && result.showCarouselControls"
                [class.fading-out]="!result.showCarouselControls"
              >
                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>

                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>

              <div
                class="image-counter desktop-only"
                *ngIf="hasMultipleImages(result)"
              >
                {{ getImageCounter(result) }}
              </div>

              <div
                class="image-dots mobile-only"
                *ngIf="hasMultipleImages(result)"
              >
                <span
                  *ngFor="let img of result.images; let i = index"
                  class="dot"
                  [class.active]="i === result.currentImageIndex"
                ></span>
              </div>

              <div class="listing-badges">
                <div *ngIf="result.is_featured" class="listing-badge featured">
                  Featured
                </div>
                <div
                  *ngIf="isNewListing(result.created_at)"
                  class="listing-badge new"
                >
                  New
                </div>
              </div>

              <div class="similarity-badge-container">
                <div
                  class="similarity-badge"
                  [style.background-color]="
                    getSimilarityColor(result.similarity_score)
                  "
                  [title]="getSimilarityDescription(result.similarity_score)"
                >
                  <svg viewBox="0 0 24 24" class="similarity-icon">
                    <path
                      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    ></path>
                  </svg>
                  {{ formatSimilarityScore(result.similarity_score) }}
                </div>
              </div>

              <div class="listing-bookmark" (click)="$event.stopPropagation()">
                <app-wishlist-heart
                  [listingId]="result.id.toString()"
                  [tableName]="result.table_name"
                  *ngIf="shouldShowWishlistButton(result)"
                ></app-wishlist-heart>
              </div>
            </div>

            <div class="listing-content" (click)="viewListing(result)">
              <div class="listing-main-info">
                <div class="listing-header">
                  <div class="listing-category-wrapper">
                    <span class="category-badge">{{
                      getCategoryDisplayName(result.category)
                    }}</span>
                    <span class="subcategory-text" *ngIf="result.subcategory">
                      • {{ getSubcategoryDisplayName(result.subcategory) }}
                    </span>
                  </div>
                  <h3 class="listing-title">{{ result.title }}</h3>
                </div>

                <div class="listing-details-grid">
                  <div class="listing-location" *ngIf="result.location">
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                      ></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ result.location }}</span>
                  </div>

                  <div
                    class="listing-views"
                    *ngIf="result.view_count && result.view_count > 0"
                  >
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span>{{ result.view_count }} views</span>
                  </div>
                </div>
              </div>

              <div class="listing-footer">
                <div class="seller-info" *ngIf="result.seller">
                  <div class="seller-avatar">
                    <svg viewBox="0 0 24 24" class="avatar-icon">
                      <path
                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                      ></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <div class="seller-details">
                    <span class="seller-name">
                      {{ result.seller.first_name }}
                      {{ result.seller.last_name }}
                    </span>
                    <span class="seller-label">Seller</span>
                  </div>
                </div>

                <div class="listing-price-wrapper">
                  <div class="listing-price">
                    <span *ngIf="result.price > 0">
                      <span class="price-currency">{{
                        result.currency || "€"
                      }}</span>
                      <span class="price-value">{{
                        result.price | number : "1.0-0"
                      }}</span>
                    </span>
                    <span *ngIf="result.price === 0" class="price-free">
                      Free
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </ng-container>
      </div>

      <div
        class="pagination-container"
        *ngIf="
          !isReverseImageSearch &&
          searchResult &&
          searchResult.pagination.pages > 1
        "
        [class.fade-in]="resultsVisible"
      >
        <div class="pagination">
          <button
            class="pagination-btn"
            [disabled]="
              searchResult.pagination.page <= 1 || isChangingSubcategory
            "
            (click)="goToPage(searchResult.pagination.page - 1)"
          >
            Previous
          </button>

          <button
            *ngFor="let page of getVisiblePages()"
            class="pagination-btn"
            [class.active]="page === searchResult.pagination.page"
            [disabled]="page === '...' || isChangingSubcategory"
            (click)="page !== '...' && goToPage(+page)"
          >
            {{ page }}
          </button>

          <button
            class="pagination-btn"
            [disabled]="
              searchResult.pagination.page >= searchResult.pagination.pages ||
              isChangingSubcategory
            "
            (click)="goToPage(searchResult.pagination.page + 1)"
          >
            Next
          </button>
        </div>
      </div>
    </div>

    <div class="loading-container" *ngIf="isLoading">
      <div class="loading-spinner"></div>
      <p>Loading results...</p>
    </div>

    <div
      class="empty-results"
      *ngIf="
        !isLoading &&
        ((searchResult && searchResult.listings.length === 0) ||
          (isReverseImageSearch && reverseSearchResults.length === 0))
      "
    >
      <div class="empty-icon">
        <svg viewBox="0 0 24 24" class="empty-svg">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <h2 class="empty-title">No Results Found</h2>
      <p class="empty-message">
        We couldn't find any listings matching your search criteria. Try
        adjusting your filters or search terms.
      </p>
    </div>
  </main>

  <app-footer></app-footer>
</div>
